import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Alert,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Link,

  Typography,

} from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { ConstantAPISContext } from "../../context/ConstantAPISContext";
import CaddeSokakAPI from "../../apis/OB/Get/CaddeSokakAPI";
import SessionStorageService from "../../services/StorageService";
import UyrukListeApi from "../../apis/OB/Get/UyrukListeApi";
import IlIlceListeAPI from "../../apis/OB/Get/IlIlceListeAPI";
import HatirlatmaKoduListeAPI from "../../apis/OB/Get/HatirlatmaKoduListeAPI";
import kpsGetUserInfoAPI from "../../apis/OB/KPS/kpsGetUserInfoAPI";
import CustomDatePicker from "../../components/OB/required-datepicker";
import BilgilendirmePopup from "../../components/OB/popups/BilgilendirmePopUp";
import KisiUyelikSaveAPI from "../../apis/OB/SaveApi/YeniUyelikSaveAPI";
import dayjs from "dayjs";
import KisiSicilSecim from "../../components/OB/popups/KisiSicilSecim";
import { safelyParseNumber } from "../../helpers/MoneyFormat";
import CustomTextField from "../../components/OB/required-text-field";
import CustomMuiTelInput from "../../components/OB/required-muitelinput";
import { MuiTelInput } from "mui-tel-input";
import { IL_KODU } from "../../config/environment";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../../context/themeProviderContext";

const validationSchema = Yup.object().shape({
  uyrukKodu: Yup.string().required("Uyruk zorunludur"),
  sicilKodu: Yup.number().required("Sicil Kodu zorunludur"),
  ePosta: Yup.string()
    .email("Geçerli bir e-posta adresi giriniz.")
    .required("E-Posta zorunludur."),
  tcKimlikNo: Yup.string()
    .length(11, "T.C Kimlik Numaranız 11 karakter olmalıdır")
    .required("T.C Kimlik Numaranız zorunludur"),
  /*  kullanciKodu: Yup.string()
    .length(11, "T.C Kimlik Numaranız 11 karakter olmalıdır")
    .required("T.C Kimlik Numaranız zorunludur"), */
  dogumTarihi: Yup.date().required("Doğum tarihi zorunludur"),
  cepTelefonu: Yup.string().required("Cep Telefonu zorunludur").length(17, "Cep Telefonu 11 haneli olmalıdır."),
  sabitTelefon: Yup.string().length(17, "Cep Telefonu 11 haneli olmalıdır."),
  sifre: Yup.string()
    .min(8, "Şifre en az 8 karakter olmalıdır")
    .matches(/[A-Z]/, "En az bir büyük harf içermelidir")
    .matches(/[0-9]/, "En az bir rakam içermelidir")
    .matches(
      /[!@#$%^&*(),.?":{}|<>]/,
      "En az bir noktalama işareti içermelidir"
    )
    .required("Şifre zorunludur"),
  sifreTekrar: Yup.string()
    .oneOf([Yup.ref("sifre"), null], "Şifreler uyuşmuyor")
    .required("Şifre tekrar zorunludur"),
  kapiNo: Yup.string().required("Dış Kapı No zorunludur"),
  hatirlatmaSorusuKodu: Yup.string().required("Dış Kapı No zorunludur"),
  hatirlatmaCevabi: Yup.string().required("Dış Kapı No zorunludur"),
  postaKodu: Yup.string()
    .matches(/^\d+$/, "Posta kodu sadece rakam içermelidir")
    .length(5, "Posta kodu 5 haneli olmalıdır"),
  daireNo: Yup.string().required("İç Kapı No zorunludur"),
  belediyeSinirlariIcindeMi: Yup.string().required(
    "Belediye Sınırları İçinde Mi? zorunludur"
  ),
  ilIlceKodu: Yup.string().when("belediyeSinirlariIcindeMi", {
    is: "H",
    then: Yup.string().required("İl/İlçe zorunludur"),

  }),
  mahalleAdi: Yup.string().required("Mahalle Adı zorunludur"),
  caddeSokakAdi: Yup.string().required("Cadde/Sokak Adı zorunludur"),

  kvkkIsAccepted: Yup.boolean().oneOf([true], "KVKK kabul edilmelidir").required("KVKK kabul edilmelidir"),
  ad: Yup.string().required("İsim zorunludur."),
  soyad: Yup.string().required("Soyisim zorunludur.")

});

const BireyselUyelik = (props: any) => {
  const { mahalleListe } = useContext(ConstantAPISContext);
  const [caddeListe, setCaddeListe] = useState<any[]>([]);
  const [uyrukData, setUyrukData] = useState<any[]>([]);
  const [disabeledInputKPS, setDisabeledInputKPS] = useState(true);
  const [disabeledInputSicilKodu, setDisabeledInputSicilKodu] = useState(false);

  const [ilIlceListe, setIlIlceListe] = useState<any[]>([]);
  const [hatirlatmaSorusuKoduDatas, sethatirlatmaSorusuKoduDatas] = useState<
    any[]
  >([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [popUpVisible, setPopUpVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [popUpBilgilendirmeContent, setPopUpBilgilendirmeContent] =
    useState("");
  const [popUpVisibleBilgilendirme, setPopUpVisibleBilgilendirme] =
    useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);

  const [kvkkPopupOpen, setKvkkPopupOpen] = useState(false);
  const { kvkkMetni }: any = useContext(ThemeContext)
  const handleKvkkLabelClick = () => {
    setKvkkPopupOpen(true);
  };

  const closeKvkkPopup = () => {
    setKvkkPopupOpen(false);
  };

  const {ilIlceKodu}:any=useContext(ThemeContext)

  let user = SessionStorageService.getUserInfo();
  const [kayitBasarili, setKayitBasarili] = useState(false);
  const closePopupSonuc = () => {
    setPopUpVisibleBilgilendirme(false);
    setPopUpBilgilendirmeContent("");
    navigate("/");
  };
  useEffect(() => {
    UyrukListeApi.getUyrukListe()
      .then((res) => setUyrukData(res.data))
      .catch((err) => console.error(err));

    IlIlceListeAPI.getIlIlceListe(undefined)
      .then((res) => setIlIlceListe(res.data))
      .catch((err) => console.error(err));

    HatirlatmaKoduListeAPI.getHatirlatmaKoduListe(undefined)
      .then((res) => sethatirlatmaSorusuKoduDatas(res.data))
      .catch((err) => console.error(err));
  }, []);

  // sicil kodu maskeleme
  const maskSicilKodu = (value?: string | number): string => {
    if (value === null || value === undefined || value === "") return "";
    const str = value.toString();
    const len = str.length;
  
    if (len <= 1) return '*';
    if (len === 2) return str.charAt(0) + '*';
    if (len <= 4) return str.charAt(0) + '*'.repeat(len - 2) + str.charAt(len - 1);
    // len >= 5
    return str.substring(0, 2) + '*'.repeat(len - 4) + str.substring(len - 2);
  };

  const handleKimlikSorgula = async (values: any, setFieldValue: any) => {
    if (!values.uyrukKodu) {
      setSnackbarMessage("Uyruk zorunludur");
      setSnackbarOpen(true);
      return;
    } else if (!values.dogumTarihi) {
      setSnackbarMessage("Doğum tarihi zorunludur");
      setSnackbarOpen(true);
      return;
    } else if (!values.tcKimlikNo || values.tcKimlikNo.length < 11) {
      setSnackbarMessage("T.C Kimlik Numaranız 11 karakterden küçük olamaz");
      setSnackbarOpen(true);
      return;
    } else {
      try {
        setSnackbarMessage("");

        setSnackbarOpen(false);
        setIsLoading(true);

        const formattedDate = dayjs(values.dogumTarihi)
          .tz("Europe/Istanbul")
          .format("YYYY-MM-DD");
        const response = await kpsGetUserInfoAPI.getKPSGetUserInfoListe(
          values.tcKimlikNo,
          formattedDate,
          "1",
          values.uyrukKodu == "1" ? false : true
        );

        if (
          response.data.sorguSonucu.length > 0 &&
          response.data.sorguSonucu[0].tcKimlikNo.toString() ==
            values.tcKimlikNo
        ) {
          console.log(response);
          const userInfo = response.data.sorguSonucu[0];
          console.log("Fetched User Info:", userInfo);

          // Güncellenen değerlere console.log ekleyerek kontrol edin
          setFieldValue("ad", userInfo.temelBilgisi.ad);
          console.log("Ad:", userInfo.temelBilgisi.ad);

          setFieldValue("soyad", userInfo.temelBilgisi.soyad);
          console.log("Soyad:", userInfo.temelBilgisi.soyad);

          setFieldValue("babaAdi", userInfo.temelBilgisi.babaAd);
          console.log("Baba Adı:", userInfo.temelBilgisi.babaAd);

          setFieldValue("dogumYeri", userInfo.temelBilgisi.dogumYer);
          console.log("Doğum Yeri:", userInfo.temelBilgisi.dogumYer);
          setDisabeledInputKPS(true);
          setIsOpen(true);
        } else {
          setSnackbarMessage(
            "Girilen bilgilerle eşleşen bir kullanıcı bulunamadı"
          );
          setSnackbarOpen(true);
        }
      } catch (error) {
        setSnackbarMessage(
          "Girilen bilgilerle eşleşen bir kullanıcı bulunamadı"
        );
        setSnackbarOpen(true);
      } finally {
        setIsLoading(false);
      }
    }
  };
  const navigate = useNavigate();
  const saveYeniUyelik = async (values: any) => {
    const transformedValues = {
      ...values,
      dogumTarihi:dayjs(values.dogumTarihi).tz("Europe/Istanbul").format("YYYY-MM-DD"),
      postaKodu: safelyParseNumber(values.postaKodu),
      sabitTelefon: safelyParseNumber(values.sabitTelefon.replace(/^\+9/, "").replaceAll(" ", "")),
      cepTelefonu: safelyParseNumber(values.cepTelefonu.replace(/^\+9/, "").replaceAll(" ", "")),
      //mahalleKodu: values.mahalleKodu == null ? null : safelyParseNumber(values.mahalleKodu),
      sicilKodu: safelyParseNumber(values.sicilKodu),
      //caddeSokakKodu: values.caddeSokakKodu == null ? null : safelyParseNumber(values.caddeSokakKodu),
      hatirlatmaSorusuKodu: values.hatirlatmaSorusuKodu.toString(),
      kullanciKodu: values.tcKimlikNo.toString(),
      mahalleKodu: values.belediyeSinirlariIcindeMi === "E" && values.mahalleKodu != null
      ? safelyParseNumber(values.mahalleKodu)
      : undefined,
      caddeSokakKodu: values.belediyeSinirlariIcindeMi === "E" && values.caddeSokakKodu != null
      ? safelyParseNumber(values.caddeSokakKodu)
      : undefined,
    };
    console.log(transformedValues)
    KisiUyelikSaveAPI.saveYeniUyelikSave(transformedValues)
      .then((res) => {
        console.log(res);
        if (res.data.sonuc === 0) {
          setPopUpBilgilendirmeContent(res.data.sonucAciklama);
          setKayitBasarili(true);

        } else {
          setPopUpBilgilendirmeContent(res.data.sonucAciklama);
        }
      })
      .catch(() => {
        setPopUpBilgilendirmeContent(
          "İşleminizi gerçekleştirirken bir hata oluştu. Lütfen tekrar deneyiniz (API error)."
        );
      })
      .finally(() => {
        setPopUpVisibleBilgilendirme(true);
      });
  };
  console.log("PROPS:", props)
  return (
    <>
      <Formik
        initialValues={{
          uyelikTipi: 1,
          tcKimlikNo: props.tcNo ?? "",
          ad: "",
          soyad: "",
          babaAdi: "",
          siteApartmanAdi: "",
          postaKodu: "",
          blokNo: "",
          dogumYeri: "",
          sicilKodu: "",
          dogumTarihi: null,
          cepTelefonu: props.cepTelefonu ?? "",
          sifre: "",
          sifreTekrar: "",
          mahalleKodu: null,
          caddeSokakKodu: null,
          kapiNo: "",
          daireNo: "",
          ilIlceKodu: ilIlceKodu,
          mahalleAdi: "",
          caddeSokakAdi: "",
          smsBilgilendirme: "E",
          mailBilgilendirme: "E",
          kullanciKodu: "",
          hatirlatmaSorusuKodu: "",
          hatirlatmaCevabi: "",
          sabitTelefon: "",
          ePosta: "",
          belediyeSinirlariIcindeMi: "E",
          kvkkIsAccepted: false,
          uyrukKodu: "1",
          vergiNo: "",
          vergiDairesiAdi: "",
          unvani: "",
          anneAdi: "",
          cinsiyeti: "",
          medeniDurumu: "",
          dini: "",
          kayitliOlduguYer: "",
          mahalleKoy: "",
          ciltNo: "",
          aileSiraNo: "",
          siraNo: "",
          cuzdanSiraNo: "",
          cuzdanSeriNo: "",
          cuzdanVerilmeTarihi: null,
          durumBilgi: "",
          guncelleyen: "",
          guncellemeTarihi: null,
          sqId: null,
          onayEH: "H",
          uyelikIptalTarihi: null,
          onayTarihi: null,
          ipAdress: "",
          kaydeden: "OB_BACKEND",
          rol: "UYE",
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => saveYeniUyelik(values)}
      >
        {({ values, setFieldValue, errors, touched, handleChange }) => {
          // eslint-disable-next-line react-hooks/rules-of-hooks
          useEffect(() => {
            if (selectedItem) {
              setFieldValue("sicilKodu", selectedItem.sicilKodu);
              setDisabeledInputSicilKodu(true);
            }
          }, [selectedItem]);
          // eslint-disable-next-line react-hooks/rules-of-hooks
          useEffect(() => {
            if (values.belediyeSinirlariIcindeMi == "E") {
              setFieldValue("ilIlceKodu", ilIlceKodu);
            } else {
              setFieldValue("ilIlceKodu", "");
            }
            setFieldValue("mahalleAdi", "");
            setFieldValue("caddeSokakAdi", "");
          }, [values.belediyeSinirlariIcindeMi]);
          // eslint-disable-next-line react-hooks/rules-of-hooks
          useEffect(() => {
            if (values.mahalleKodu) {
              CaddeSokakAPI.getCaddeSokakListe(undefined, values.mahalleKodu)
                .then((res) => setCaddeListe(res.data))
                .catch((err) => console.error(err));
            }
          }, [values.mahalleKodu]);
          return (
            <Form>
              <div className="row ">
                <div className="col-lg-6">
                  <div className="card w-100">
                    <div className="card-body w-100">
                      <div className="row">
                        <div className="d-flex flex-column">
                          <h5>Üyelik Bilgileri</h5>
                          {snackbarMessage && (
                            <Alert
                              severity="error"
                              style={{
                                marginTop: "0.6rem",
                                width: "fit-content",
                              }}
                            >
                              {snackbarMessage}
                            </Alert>
                          )}
                        </div>
                        <KisiSicilSecim
                          setItem={setSelectedItem}
                          isOpen={isOpen}
                          setIsOpen={setIsOpen}
                          tcNo={values.tcKimlikNo}
                        />
                        <hr className="my-3" />
                        <div className="col-md-6 mb-3">
                          <CustomTextField
                            fullWidth
                            size="small"
                            select
                            label="Uyruk *"

                            variant="outlined"
                            value={values.uyrukKodu}
                            onChange={handleChange}
                            name="uyrukKodu"
                            error={
                              touched.uyrukKodu && Boolean(errors.uyrukKodu)
                            }
                          >
                            <MenuItem value="">Seçiniz</MenuItem>
                            {uyrukData.map((option) => (
                              <MenuItem
                                key={option.uyrukKodu}
                                value={option.uyrukKodu}
                              >
                                {option.uyrukAdi}
                              </MenuItem>
                            ))}
                          </CustomTextField>
                        </div>
                        <div className="col-md-6 mb-3">
                          <CustomTextField
                            fullWidth
                            size="small"
                            label="T.C Kimlik Numaranız *"
                            variant="outlined"
                            value={values.tcKimlikNo}
                            onChange={handleChange}
                            disabled={true}
                            name="tcKimlikNo"
                            error={
                              touched.tcKimlikNo && Boolean(errors.tcKimlikNo)
                            }
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <CustomDatePicker
                            label="Doğum Tarihiniz *"
                            value={values.dogumTarihi}
                            onChange={(value: any) =>
                              setFieldValue("dogumTarihi", value)
                            }
                            slotProps={{
                              textField: {
                                error:
                                  touched.dogumTarihi &&
                                  Boolean(errors.dogumTarihi),
                                  fullWidth: true,

                              },
                            }}
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <Button
                            size="small"
                            color="error"
                            fullWidth
                            onClick={() =>
                              handleKimlikSorgula(values, setFieldValue)
                            }
                          >
                            {isLoading ? (
                              <CircularProgress
                                className="text-white"
                                size={22}
                              />
                            ) : (
                              "Kimlik Bilgilerimi Sorgula"
                            )}
                          </Button>
                        </div>
                        <hr className="col-12 mb-3" />
                        <div className="col-md-6 mb-3">
                          <TextField
                            fullWidth
                            size="small"
                            label="Belediye Sicil Kodu"
                            variant="outlined"
                            disabled={true}
                            value={maskSicilKodu(values.sicilKodu)}
                            name="sicilKodu"
                          />
                        </div>
                        <div className="col-md-3 mb-3">
                          <TextField
                            fullWidth
                            size="small"
                            label="Adınız"
                            disabled={true}

                            variant="outlined"
                            value={values.ad}
                            name="ad"
                          />
                        </div>
                        <div className="col-md-3 mb-3">
                          <TextField
                            fullWidth
                            size="small"
                            label="Soyadınız"
                            disabled={true}
                            variant="outlined"
                            value={values.soyad}
                            name="soyad"
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <TextField
                            fullWidth
                            size="small"
                            label="Baba Adınız"
                            variant="outlined"
                            disabled={true}
                            value={values.babaAdi}
                            name="babaAdi"
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <TextField
                            fullWidth
                            size="small"
                            label="Doğum Yeriniz"
                            variant="outlined"
                            disabled={true}
                            value={values.dogumYeri}
                            name="dogumYeri"
                          />
                        </div>
                        <h5>İletişim Bilgileri</h5>
                        <hr className="my-3" />
                        <div className="col-md-6 mb-3">
                          <CustomMuiTelInput
                            name="cepTelefonu"
                            fullWidth
                            defaultCountry="TR"
                            onlyCountries={["TR"]}
                            className="mb-3"
                            size="small"
                            label="Cep Telefonu *"
                            disabled={true}
                            value={values.cepTelefonu}
                            error={
                              errors.cepTelefonu &&
                                touched.cepTelefonu
                                ? true
                                : false
                            }
                            onChange={(value: any) => {
                              const prefix = "+90";
                              if (!value.startsWith(prefix)) {
                                value = prefix + value.replace(/^\+90/, "");
                              }
                              setFieldValue("cepTelefonu", value);
                            }}
                            variant="outlined"
                          />

                        </div>
                        <div className="col-md-6 mb-3">
                          <MuiTelInput
                            name="sabitTelefon"
                            fullWidth
                            defaultCountry="TR"
                            onlyCountries={["TR"]}
                            className="mb-3"
                            size="small"
                            label="Sabit Telefon"
                            disabled={!disabeledInputKPS}

                            value={values.sabitTelefon}
                            inputProps={{ maxLength: 17 }}
                            error={
                              errors.sabitTelefon &&
                                touched.sabitTelefon
                                ? true
                                : false
                            }
                            onChange={(value: any) => {
                              const prefix = "+90";
                              if (!value.startsWith(prefix)) {
                                value = prefix + value.replace(/^\+90/, "");
                              }
                              setFieldValue("sabitTelefon", value);
                            }}
                            variant="outlined"
                          />

                        </div>
                        <div className="col-md-6 mb-3">
                          <CustomTextField
                            fullWidth
                            size="small"
                            select
                            label="Güvenlik Sorunuz *"
                            variant="outlined"
                            value={values.hatirlatmaSorusuKodu}
                            onChange={handleChange}
                            disabled={!disabeledInputKPS}

                            error={
                              touched.hatirlatmaSorusuKodu &&
                              Boolean(errors.hatirlatmaSorusuKodu)
                            }
                            name="hatirlatmaSorusuKodu"
                          >
                            <MenuItem value="">Seçiniz</MenuItem>
                            {hatirlatmaSorusuKoduDatas.map((option) => (
                              <MenuItem
                                key={option.hatirlatmaKodu}
                                value={option.hatirlatmaKodu}
                              >
                                {option.hatirlatmaSorusu}
                              </MenuItem>
                            ))}
                          </CustomTextField>
                        </div>
                        <div className="col-md-6 mb-3">
                          <CustomTextField
                            fullWidth
                            size="small"
                            label="Cevap *"
                            variant="outlined"
                            disabled={!disabeledInputKPS}

                            error={
                              touched.hatirlatmaCevabi &&
                              Boolean(errors.hatirlatmaCevabi)
                            }
                            value={values.hatirlatmaCevabi}
                            onChange={handleChange}
                            name="hatirlatmaCevabi"
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <CustomTextField
                            fullWidth
                            size="small"
                            label="E-Posta Adresiniz *"
                            variant="outlined"
                            disabled={!disabeledInputKPS}
                            error={
                              touched.ePosta &&
                              Boolean(errors.ePosta)
                            }

                            value={values.ePosta}
                            onChange={handleChange}
                            name="ePosta"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="card w-100">
                    <div className="card-body w-100">
                      <div className="row">
                        <h5>Bilgilendirme</h5>
                        <hr className="my-3" />
                        <div className="col-lg-6 mb-3">
                          <div className="card w-100">
                            <div className="card-body w-100">
                              <h6>SMS İle Bilgilendirme</h6>
                              <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                row={true}
                                value={values.smsBilgilendirme}

                                onChange={handleChange}
                                name="smsBilgilendirme"
                              >
                                <FormControlLabel
                                  value="E"
                                  disabled={!disabeledInputKPS}

                                  control={<Radio />}
                                  label="Evet"
                                />
                                <FormControlLabel
                                  value="H"
                                  disabled={!disabeledInputKPS}

                                  control={<Radio />}
                                  label="Hayır"
                                />
                              </RadioGroup>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 mb-3">
                          <div className="card w-100">
                            <div className="card-body w-100">
                              <h6>E-Posta İle Bilgilendirme</h6>
                              <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                row={true}
                                value={values.mailBilgilendirme}
                                onChange={handleChange}
                                name="mailBilgilendirme"
                              >
                                <FormControlLabel
                                  value="E"
                                  disabled={!disabeledInputKPS}

                                  control={<Radio />}
                                  label="Evet"
                                />
                                <FormControlLabel
                                  value="H"
                                  disabled={!disabeledInputKPS}

                                  control={<Radio />}
                                  label="Hayır"
                                />
                              </RadioGroup>
                            </div>
                          </div>
                        </div>
                        <h5>İletişim Adresi Bilgileri</h5>
                        <hr className="my-3" />
                        <div className="col-md-4 mb-3">
                          <TextField
                            fullWidth
                            select
                            size="small"
                            disabled={!disabeledInputKPS}

                            label="Belediye Sınırları İçinde Mi?"
                            variant="outlined"
                            value={values.belediyeSinirlariIcindeMi}
                            onChange={handleChange}
                            name="belediyeSinirlariIcindeMi"
                            error={
                              touched.belediyeSinirlariIcindeMi &&
                              Boolean(errors.belediyeSinirlariIcindeMi)
                            }
                          >
                            <MenuItem value="E">Evet</MenuItem>
                            <MenuItem value="H">Hayır</MenuItem>
                          </TextField>
                        </div>
                        {
                          values.ilIlceKodu == ilIlceKodu ?
                            <>
                              <div className="col-md-4 mb-3">
                                <CustomTextField
                                  fullWidth
                                  select
                                  label="Mahalle *"
                                  disabled={!disabeledInputKPS}

                                  size="small"
                                  value={values.mahalleKodu}
                                  onChange={(e: any) => {
                                    const selectedOption = mahalleListe.find(
                                      (option) =>
                                        option.mahalleKodu === Number(e.target.value)
                                    );
                                    setFieldValue(
                                      "mahalleKodu",
                                      Number(e.target.value)
                                    );
                                    setFieldValue(
                                      "mahalleAdi",
                                      selectedOption ? selectedOption.mahalleAdi : ""
                                    );
                                    setFieldValue("caddeSokakKodu", null);
                                  }}
                                  error={
                                    touched.mahalleAdi && Boolean(errors.mahalleAdi)
                                  }
                                >
                                  <MenuItem value="">Seçiniz..</MenuItem>
                                  {mahalleListe.map((option) => (
                                    <MenuItem
                                      key={option.mahalleKodu}
                                      value={option.mahalleKodu}
                                    >
                                      {option.mahalleAdi}
                                    </MenuItem>
                                  ))}
                                </CustomTextField>
                              </div>
                              <div className="col-md-4 mb-3">
                                <CustomTextField
                                  fullWidth
                                  size="small"
                                  select
                                  disabled={!disabeledInputKPS}

                                  label="Cadde/Sokak *"
                                  value={values.caddeSokakKodu}
                                  onChange={(e: any) => {
                                    const selectedOption = caddeListe.find(
                                      (option) =>
                                        option.caddeSokakKodu ===
                                        Number(e.target.value)
                                    );
                                    setFieldValue(
                                      "caddeSokakKodu",
                                      Number(e.target.value)
                                    );
                                    setFieldValue(
                                      "caddeSokakAdi",
                                      selectedOption
                                        ? selectedOption.caddeSokakAdi
                                        : ""
                                    );
                                  }}
                                  error={
                                    touched.caddeSokakAdi &&
                                    Boolean(errors.caddeSokakAdi)
                                  }
                                >
                                  <MenuItem value="">Seçiniz..</MenuItem>
                                  {caddeListe.map((option) => (
                                    <MenuItem
                                      key={option.caddeSokakKodu}
                                      value={option.caddeSokakKodu}
                                    >
                                      {option.caddeSokakAdi}
                                    </MenuItem>
                                  ))}
                                </CustomTextField>
                              </div></> :
                            <>
                              <div className="col-md-4 mb-3">
                                <CustomTextField
                                  fullWidth
                                  disabled={!disabeledInputKPS}

                                  size="small"
                                  label="Mahalle Adı *"
                                  variant="outlined"
                                  value={values.mahalleAdi}
                                  onChange={handleChange}
                                  name="mahalleAdi"
                                  error={touched.mahalleAdi && Boolean(errors.mahalleAdi)}
                                />
                              </div>
                              <div className="col-md-4 mb-3">
                                <CustomTextField
                                  fullWidth
                                  disabled={!disabeledInputKPS}

                                  size="small"
                                  label="Cadde/Sokak Adı *"
                                  variant="outlined"
                                  value={values.caddeSokakAdi}
                                  onChange={handleChange}
                                  name="caddeSokakAdi"
                                  error={touched.caddeSokakAdi && Boolean(errors.caddeSokakAdi)}
                                />
                              </div>
                            </>

                        }
                        <div className="col-md-2 mb-3">
                          <CustomTextField
                            disabled={!disabeledInputKPS}

                            fullWidth
                            size="small"
                            label="Kapı No *"
                            variant="outlined"
                            value={values.kapiNo}
                            onChange={handleChange}
                            name="kapiNo"
                            error={touched.kapiNo && Boolean(errors.kapiNo)}
                          />
                        </div>
                        <div className="col-md-2 mb-3">
                          <CustomTextField
                            fullWidth
                            size="small"
                            disabled={!disabeledInputKPS}

                            label="Daire No *"
                            variant="outlined"
                            value={values.daireNo}
                            onChange={handleChange}
                            name="daireNo"
                            error={touched.daireNo && Boolean(errors.daireNo)}
                          />
                        </div>
                        <div className="col-md-4 mb-3">
                          <TextField
                            fullWidth
                            disabled={!disabeledInputKPS}

                            size="small"
                            label="Site/Apartman Adı"
                            variant="outlined"
                            value={values.siteApartmanAdi}
                            onChange={handleChange}
                            name="siteApartmanAdi"
                          />
                        </div>
                        <div className="col-md-2 mb-3">
                          <TextField
                            fullWidth
                            disabled={!disabeledInputKPS}

                            size="small"
                            label="Blok No"
                            variant="outlined"
                            value={values.blokNo}
                            onChange={handleChange}
                            name="blokNo"
                          />
                        </div>
                        <div className="col-md-2 mb-3">
                          <TextField
                            fullWidth
                            size="small"
                            disabled={!disabeledInputKPS}

                            label="Posta Kodu"
                            variant="outlined"
                            type="text"
                            inputProps={{ maxLength: 5 }}
                            value={values.postaKodu}
                            error={
                              touched.postaKodu && Boolean(errors.postaKodu)
                            }
                            onChange={handleChange}
                            name="postaKodu"
                          />
                        </div>
                        <div className="col-md-4 mb-3">
                          <CustomTextField
                            fullWidth
                            disabled={!disabeledInputKPS}

                            size="small"
                            label="İl/İlçe *"
                            select
                            value={values.ilIlceKodu}
                            onChange={handleChange}
                            name="ilIlceKodu"
                            error={
                              touched.ilIlceKodu && Boolean(errors.ilIlceKodu)
                            }

                            style={{
                              display:
                                values.belediyeSinirlariIcindeMi === "H"
                                  ? "flex"
                                  : "none",
                            }}
                          >
                            <MenuItem value="">Seçiniz</MenuItem>
                            {ilIlceListe.map((option) => (
                              <MenuItem
                                key={option.ilIlceKodu}
                                value={option.ilIlceKodu}
                              >
                                {option.ilIlceAdi}
                              </MenuItem>
                            ))}
                          </CustomTextField>
                        </div>
                        <h5 className="my-3">Şifre</h5>
                        <hr className="my-3" />
                        <p className="text-danger">{errors.sifre}</p>
                        <div className="col-md-6 mb-3">
                          <CustomTextField
                            fullWidth
                            disabled={!disabeledInputKPS}

                            size="small"
                            label="Şifreniz *"
                            variant="outlined"
                            type="password"
                            value={values.sifre}
                            onChange={handleChange}
                            name="sifre"
                            error={touched.sifre && Boolean(errors.sifre)}
                          />
                        </div>
                        <div className="col-md-6 mb-3">
                          <CustomTextField
                            fullWidth
                            disabled={!disabeledInputKPS}

                            size="small"
                            label="Şifre Tekrar *"
                            variant="outlined"
                            type="password"
                            value={values.sifreTekrar}
                            onChange={handleChange}
                            name="sifreTekrar"
                            error={
                              touched.sifreTekrar && Boolean(errors.sifreTekrar)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-between px-3">
                <div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={values.kvkkIsAccepted}
                        onChange={handleChange}
                        disabled={!disabeledInputKPS}
                        name="kvkkIsAccepted"
                        color="error"
                      />
                    }
                    label={
                      <Link
                        color={errors.kvkkIsAccepted ? "error" : "inherit"}
                        style={{ cursor: "pointer" }}
                        onClick={handleKvkkLabelClick}
                      >
                        KVKK Metnini Kabul Ediyorum.
                      </Link>
                    }
                  />
                  {touched.kvkkIsAccepted && errors.kvkkIsAccepted && (
                    <Typography color="error" variant="caption" display="block">
                      {errors.kvkkIsAccepted}
                    </Typography>
                  )}
                </div>
                <Button type="submit" disabled={isLoading}>
                  Kayıt Ol
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
      <BilgilendirmePopup
        editDescription={popUpBilgilendirmeContent}
        basvuruTuruId={-5}
        isSorunBildirPopup={!kayitBasarili}
        closePopup={closePopupSonuc}
        open={popUpVisibleBilgilendirme}
      />
      <Dialog open={kvkkPopupOpen} onClose={closeKvkkPopup} fullWidth
        maxWidth="md"
        sx={{ '& .MuiDialog-paper': { width: '80%', maxWidth: 'none' } }}>
        <DialogTitle>KVKK Metni</DialogTitle>
        <DialogContent dividers>
          <Typography>
            {kvkkMetni || ""}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeKvkkPopup} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BireyselUyelik;
